export const CONFIG = {
  "APP_ENDPOINT": "https://f21rjypk91.execute-api.ap-southeast-2.amazonaws.com/prod",
  "APP_USER_POOL_ID": "ap-southeast-2_mYHGLz30D",
  "APP_CLIENT_ID": "1l860ubgi68pm55fpn1ch3qfj",
  "APP_IOT_REGION": "ap-southeast-2",
  "APP_IOT_HOST": "a2e979oqcq3co8-ats.iot.ap-southeast-2.amazonaws.com",
  "APP_CONTROLPANEL_DEVICE_IP": "https://qc.airgroup.com.au",
  "APP_URL": "appv2.coolbreeze.com.au/#",
  "APP_VERSION": "b079336"
}


// WEBPACK FOOTER //
// ./src/utils/env-config.js